import React from 'react'

const NotFound = () => {
  return (
    <div>
      <h1>NotFount</h1>
    </div>
  )
}

export default NotFound;
